import React from 'react';
import { Roles } from '../../../utils/enums/Roles';
import { appContext } from '../../appContext';

export function useUserHasRole() {
    const currentAppContext = React.useContext(appContext.context);
    return {
        userHasRole: (roles: Roles[]) => roles.indexOf(currentAppContext.userRole) !== -1,
    };
}
